import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router';

import { defaultAllowedRoles, manager, teamAdmin } from '../../constants/appConstants';
import PageLoader from '../loaders/pageLoader';
import { requestsLoader } from '../loaders/requests';
import { rootLoader } from '../loaders/rootLoader';
import ProtectedRoute from '../protectedRoute';
import { queryClient } from '../queryClient';

const RequestPage = lazy(() => import('../../components/pages/request'));

const approvalsPath = '/approvals' as const;

// OLd urls in email templates contain
// /activity/:approvalId
export const approvalRoutes = {
	path: approvalsPath,
	element: <Outlet />,
	children: [
		{
			path: ':approvalId',
			element: (
				<ProtectedRoute allowedRoles={[...defaultAllowedRoles, teamAdmin, manager]}>
					<Suspense fallback={<PageLoader />}>
						<RequestPage />
					</Suspense>
				</ProtectedRoute>
			),
			loader: async (ctx: any) => {
				const [rootData, requestData] = await Promise.all([
					rootLoader({ queryClient, ...ctx }),
					requestsLoader({ queryClient, ...ctx }),
				]);
				return {
					...rootData,
					...requestData,
				};
			},
		},
	],
};
